export const MITS_AMENITIES = [
  {
    value: 'Other',
    text: 'Other',
    disabled: false,
  },
  {
    value: 'Availability24Hours',
    text: 'Availability 24 Hours',
    disabled: false,
  },
  {
    value: 'AccentWalls',
    text: 'Accent Walls',
    disabled: false,
  },
  {
    value: 'BasketballCourt',
    text: 'Basketball Court',
    disabled: false,
  },
  {
    value: 'Bilingual',
    text: 'Bilingual',
    disabled: false,
  },
  {
    value: 'BoatDocks',
    text: 'Boat Docks',
    disabled: false,
  },
  {
    value: 'BusinessCenter',
    text: 'Business Center',
    disabled: false,
  },
  {
    value: 'CarWashArea',
    text: 'Car Wash Area',
    disabled: false,
  },
  {
    value: 'ChildCare',
    text: 'Child Care',
    disabled: false,
  },
  {
    value: 'ClubDiscount',
    text: 'Club Discount',
    disabled: false,
  },
  {
    value: 'ClubHouse',
    text: 'Club House',
    disabled: false,
  },
  {
    value: 'ConferenceRoom',
    text: 'Conference Room',
    disabled: false,
  },
  {
    value: 'Concierge',
    text: 'Concierge',
    disabled: false,
  },
  {
    value: 'CoverPark',
    text: 'Cover Park',
    disabled: false,
  },
  {
    value: 'DoorAttendant',
    text: 'Door Attendant',
    disabled: false,
  },
  {
    value: 'FitnessCenter',
    text: 'Fitness Center',
    disabled: false,
  },
  {
    value: 'Elevator',
    text: 'Elevator',
    disabled: false,
  },
  {
    value: 'FreeWeights',
    text: 'Free Weights',
    disabled: false,
  },
  {
    value: 'FurnishedAvailable',
    text: 'Furnished Available',
    disabled: false,
  },
  {
    value: 'GamingStations',
    text: 'Gaming Stations',
    disabled: false,
  },
  {
    value: 'Garage',
    text: 'Garage',
    disabled: false,
  },
  {
    value: 'Gate',
    text: 'Gate',
    disabled: false,
  },
  {
    value: 'GroceryService',
    text: 'Grocery Service',
    disabled: false,
  },
  {
    value: 'GroupExcercise',
    text: 'Group Exercise',
    disabled: false,
  },
  {
    value: 'GuestRoom',
    text: 'Guest Room',
    disabled: false,
  },
  {
    value: 'HighSpeed',
    text: 'High Speed',
    disabled: false,
  },
  {
    value: 'Housekeeping',
    text: 'Housekeeping',
    disabled: false,
  },
  {
    value: 'HouseSitting',
    text: 'House Sitting',
    disabled: false,
  },
  {
    value: 'JoggingWalkingTrails',
    text: 'Jogging Walking Trails',
    disabled: false,
  },
  {
    value: 'LakeFront',
    text: 'Lake Front',
    disabled: false,
  },
  {
    value: 'LakeAccess',
    text: 'Lake Access',
    disabled: false,
  },
  {
    value: 'Laundry',
    text: 'Laundry',
    disabled: false,
  },
  {
    value: 'Library',
    text: 'Library',
    disabled: false,
  },
  {
    value: 'MealService',
    text: 'Meal Service',
    disabled: false,
  },
  {
    value: 'MediaRoom',
    text: 'Media Room',
    disabled: false,
  },
  {
    value: 'MultiUseRoom',
    text: 'Multi Use Room',
    disabled: false,
  },
  {
    value: 'NightPatrol',
    text: 'Night Patrol',
    disabled: false,
  },
  {
    value: 'OnSiteMaintenance',
    text: 'On Site Maintenance',
    disabled: false,
  },
  {
    value: 'OnSiteManagement',
    text: 'On Site Management',
    disabled: false,
  },
  // Not a MITS type: the backend saves it as Other with this name (FES-1860).
  {
    value: 'Outdoor Seating Area / Picnic Area',
    text: 'Outdoor Seating Area / Picnic Area',
    disabled: false,
  },
  {
    value: 'PackageReceiving',
    text: 'Package Receiving',
    disabled: false,
  },
  {
    value: 'PerDiemAccepted',
    text: 'Per Diem Accepted',
    disabled: false,
  },
  {
    value: 'Pool',
    text: 'Pool',
    disabled: false,
  },
  {
    value: 'PlayGround',
    text: 'Play Ground',
    disabled: false,
  },
  {
    value: 'Racquetball',
    text: 'Racquetball',
    disabled: false,
  },
  {
    value: 'RecRoom',
    text: 'Rec Room',
    disabled: false,
  },
  {
    value: 'Recycling',
    text: 'Recycling',
    disabled: false,
  },
  {
    value: 'Sauna',
    text: 'Sauna',
    disabled: false,
  },
  {
    value: 'ShortTermLease',
    text: 'Short Term Lease',
    disabled: false,
  },
  {
    value: 'SmokeFree',
    text: 'Smoke Free',
    disabled: false,
  },
  {
    value: 'Spa',
    text: 'Spa',
    disabled: false,
  },
  {
    value: 'StorageSpace',
    text: 'Storage Space',
    disabled: false,
  },
  {
    value: 'Sundeck',
    text: 'Sundeck',
    disabled: false,
  },
  {
    value: 'TennisCourt',
    text: 'Tennis Court',
    disabled: false,
  },
  {
    value: 'Transportation',
    text: 'Transportation',
    disabled: false,
  },
  {
    value: 'TVLounge',
    text: 'TV Lounge',
    disabled: false,
  },
  {
    value: 'ValetTrash',
    text: 'Valet Trash',
    disabled: false,
  },
  {
    value: 'Vintage',
    text: 'Vintage',
    disabled: false,
  },
  {
    value: 'VolleyballCourt',
    text: 'Volleyball Court',
    disabled: false,
  },
  {
    value: 'WirelessInternet',
    text: 'Wireless Internet',
    disabled: false,
  },
];
